import { RefreshCw, Cable } from "lucide-react";
import { useTranslation } from "react-i18next";

interface ConnectionProgressBannerProps {
	className?: string;
}

export const ConnectionProgressBanner = ({ className = "" }: ConnectionProgressBannerProps) => {
	const { t } = useTranslation();

	return (
		<div className={`w-full bg-blue-50 border border-blue-200 rounded-sm p-3 mb-4 animate-pulse ${className}`}>
			<div className="flex items-center gap-2">
				<Cable className="h-4 w-4 text-blue-500 animate-bounce" />
				<p className="text-xs font-medium text-blue-900">
					{t("settings.integrations.fetchingConnection", "Fetching recent connection")}
				</p>
				<div className="ml-auto">
					<div className="flex space-x-1">
						<div className="w-1 h-1 bg-blue-500 rounded-full animate-ping"></div>
						<div className="w-1 h-1 bg-blue-500 rounded-full animate-ping" style={{ animationDelay: '0.2s' }}></div>
						<div className="w-1 h-1 bg-blue-500 rounded-full animate-ping" style={{ animationDelay: '0.4s' }}></div>
					</div>
				</div>
			</div>
		</div>
	);
};
